<template>
    <div class="ml-3">
        <label>Imagen Deportista</label>
        <b-img v-if="base.foto_perfil" height="300" width="300" thumbnail fluid :src="base.foto_perfil" alt="Foto de perfil" class="mb-2"/>
        <label for="">Si sube una nueva imagen se cambia automáticamente</label>
        <Dropzone 
            v-if="url"
            :url="url"
            @success="vdropzone_success_handler"
        />
    </div>
</template>

<script>
    import Dropzone from '@/components/common/Dropzone';

    export default {
        props: ['base'],
        data(){
            return {
                url: this.config.API_BASE + "/f/guardar-foto-deportista" + "?id=" + this.base.id,
                foto: null,
            }
        },
        methods: {
            vdropzone_success_handler(file, response) {
                this.base.foto_url = response.url;
            },
        },
        components: {
            Dropzone
        }
    }
</script>